import React, { forwardRef, Ref, createRef, MutableRefObject } from "react";
import {
  Button,
  Box,
  Typography,
  Grid,
  makeStyles,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import { ITag } from "resources/interface";
import { ActionType } from "resources/constants";
import { useLocationContext } from "resources/hooks";

import { ReactComponent as CloseIcon } from "assets/icons/cross-icon.svg";

const useStyles = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  menu: {
    display: "flex",
    flexWrap: "wrap",
  },
  menuItem: {
    width: "fit-content",
  },
}));

interface IProps {
  tags: Array<ITag>;
  action(): void;
}
const TagsAZ = forwardRef(({ tags, action }: IProps, ref: Ref<any>) => {
  const classes = useStyles();
  const { dispatch } = useLocationContext();
  let alpha = "";
  let index = -1;
  const refArray = [
    ...Array(26)
      .fill(null)
      .map((_, index) => createRef() as MutableRefObject<HTMLDivElement>),
  ];

  const chooseTag = (tag: ITag) => {
    dispatch({
      type: ActionType.addFilterTag,
      selectedTag: tag,
    });
    action();
  };

  const scroller = (index: number) => {
    const { current } = refArray[index];

    if (current) {
      current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    }
  };

  return (
    <Dialog open={true} onClose={action} maxWidth="md" ref={ref}>
      <DialogTitle disableTypography>
        <Box className={classes.dialogTitle}>
          <Typography variant="h6">A-Z tags</Typography>
          <IconButton aria-label="close" onClick={action}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List className={classes.menu}>
          {refArray.map((_, index) => (
            <ListItem
              button
              onClick={() => scroller(index)}
              className={classes.menuItem}
            >
              <ListItemText primary={String.fromCharCode(65 + index)} />
            </ListItem>
          ))}
        </List>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          {tags.map((tag) => {
            const rc = [];

            if (
              tag.filter_item_title.match(/^[a-z]/i) &&
              alpha !== tag.filter_item_title[0]
            ) {
              alpha = tag.filter_item_title[0];
              rc.push(
                <Grid item xs={12} ref={refArray[index + 1]} key={index}>
                  {alpha}
                </Grid>
              );
              index += 1;
            }
            rc.push(
              <Grid item key={tag.id}>
                <Button variant="outlined" onClick={() => chooseTag(tag)}>
                  <Typography variant="button" display="block" gutterBottom>
                    {tag.filter_item_title}
                  </Typography>
                </Button>
              </Grid>
            );
            return rc;
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
});

export default TagsAZ;
